import type { Component } from 'vue';
import TimeOutlineIcon from '@/graphics/icons/TimeOutlineIcon.vue';
import CalendarOutlineIcon from '@/graphics/icons/CalendarOutlineIcon.vue';

export const CORPORATE_ONBOARDING_GUIDED_SELECTION = {
  JOB_POST: 'job-post',
  SEARCH: 'search',
} as const;

export type CorporateOnboardingGuidedSelectionOption =
  (typeof CORPORATE_ONBOARDING_GUIDED_SELECTION)[keyof typeof CORPORATE_ONBOARDING_GUIDED_SELECTION];

export interface CorporateOnboardingGuidedSelectionOptionConfig {
  value: CorporateOnboardingGuidedSelectionOption;
  label: string;
  icon: Component;
}

export const CORPORATE_ONBOARDING_GUIDED_SELECTION_OPTIONS: CorporateOnboardingGuidedSelectionOptionConfig[] = [
  {
    value: CORPORATE_ONBOARDING_GUIDED_SELECTION.JOB_POST,
    label: 'I need care soon',
    icon: TimeOutlineIcon,
  },
  {
    value: CORPORATE_ONBOARDING_GUIDED_SELECTION.SEARCH,
    label: "I'm exploring or planning ahead",
    icon: CalendarOutlineIcon,
  },
];
